<template>
    <div class="side-wrap">
        <template v-if="!!!item.children">
            <el-menu-item :index="item.name" @click.native="goToRoute(item)">
                <span class="title"> {{$t('route.'+item.name)}}</span>
            </el-menu-item>
        </template>

        <el-submenu v-else :index="item.name">
            <template slot="title" >
                <span class="title">{{$t('route.'+item.name)}}</span>
            </template>

            <template v-for="child in item.children">
                <sidebar-item
                        v-if="child.children&&child.children.length>0"
                        :item="child"
                        @goToRoute="goToRoute"
                        />
                <el-menu-item v-else  :index="child.name" @click.native="goToRoute(child)">
                    <span class="title s-title" >{{$t('route.'+child.name)}}</span>
                </el-menu-item>
            </template>
        </el-submenu>
    </div>
</template>

<script>

    export default {
        name: 'SidebarItem',
        props: {
            item: {
                type: Object,
                required: true
            }
        },
        methods:{
            goToRoute(item){
                this.$emit('goToRoute',item)
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "SidebarItem.scss";
</style>
